import React from "react";
import type { NextPage } from "next";
import Image from "next/image";
import img1 from "@/assets/images/labgrown_banner.jpg";
import styles from "@/styles/houseOfSenco.module.scss";

const House = () => {
  return (
    <div className={styles.the_house}>
      <div className={styles.container}>
        <div className={styles.the_house_head}>
          THE <strong>HOUSE</strong>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="pe-md-5">
              <div className={styles.ex_heading}>
                EXPERIENCE <br /> THE
                <br /> ARTISTRY
                <br /> OF
                <br /> LUXURY
              </div>
              <p>
                House of Senco from Senco Gold and Diamonds redefines luxury
                with an 80-year legacy of elegance and trust. We invite you to
                experience a world where timeless sophistication meets
                unparalleled craftsmanship.
              </p>
              <p>
                Our mission is to be the quintessential destination for those
                who seek the finest in luxury. From exquisite bags to gold and
                diamond jewellery, Lab Grown Diamonds, and men’s jewellery,
                House of Senco offers a curated selection that transcends the
                ordinary. We cater to the most discerning tastes, creating an
                atmosphere of prestige and indulgence that is, aspirational.
              </p>
              <p>
                With decades of expertise, we bring together the finest luxury
                designs from our house of brands, Sennes, Everlite and Aham, all
                under one roof. Our commitment to excellence and customer trust
                ensures that every piece embodies timeless sophistication and
                exclusivity.
              </p>
              <p>
                At House of Senco, we are dedicated to crafting an experience of
                redefined luxury. Our vision is to become synonymous with
                opulence, setting new standards in the pursuit of refined living
                while honouring our rich heritage and legacy. Indulge in the
                extraordinary and discover a world where luxury is timeless.
              </p>
              {/* <a className={styles.know}>KNOW MORE</a> */}
            </div>
          </div>
          <div className="col-md-8">
            <div className="row g-3">
              <div className="col-md-12">
                <div className={styles.know_video}>
                  <Image src={img1} alt="" />
                </div>
              </div>
              <div className="col-md-6 pointer-cursor">
                <div className={styles.know_video}>
                  <Image
                    onClick={() =>
                      window.open(
                        "https://www.sennes.in/category/bags-and-accessories",
                        "_blank"
                      )
                    }
                    src={require("@/assets/images/The-House_1.jpg")}
                    alt="our collecttions"
                  />
                </div>
              </div>
              <div className="col-md-6 pointer-cursor">
                <div className={styles.know_video}>
                  <Image
                    onClick={() =>
                      window.open(
                        "https://www.sennes.in/category/bags-and-accessories",
                        "_blank"
                      )
                    }
                    src={require("@/assets/images/The-House_2.jpg")}
                    alt="our collecttions"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default House;
